import React from 'react'
import ProfileSetting from '../../Components/ProfileSetting/ProfileSetting'

function UserProfile() {
  return (
  <div className="account-setting-container">
            <div className="account-setting-pad">
            <span className="account-setting-title">Account Settings</span>
            <p className="account-setting-description">Edit your name, change your password and update profile</p>
            <ProfileSetting />
            </div>
      </div>
  )
}

export default UserProfile
